import React from 'react'
import TermsofService from '../components/terms-of-service'

export default function TermsOfServicePage() {
    return <TermsofService />
}
